export const loadStateFromJSON = (event, { setRows, setColumns, setListItems, onReceiveSavedStyles }) => {
    const file = event.target.files[0];
    if (!file) return;

    // ✅ Accept both .onewriter and .json extensions
    const lowerName = file.name.toLowerCase();
    if (!lowerName.endsWith('.onewriter') && !lowerName.endsWith('.json')) {
        alert('Only .onewriter or .json files can be loaded.');
        console.error(`File "${file.name}" is not a supported file type.`);
        return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
        try {
            const loadedData = JSON.parse(e.target.result);
            if (loadedData.rows && loadedData.columns && loadedData.tagLibrary) {
                const reconstructedRows = loadedData.rows.map(row => {
                    const matchingSelections = loadedData.selectedTags?.find(sel => sel.rowId === row.id);
                    if (matchingSelections) {
                        loadedData.columns.forEach(col => {
                            const key = `column${col.id}`;
                            row[`${key}_selected`] = matchingSelections.selections[key] || [];
                        });
                    }
                    return row;
                });

                setRows(reconstructedRows);
                setColumns(loadedData.columns);
                setListItems(loadedData.tagLibrary);
            } else {
                console.error('Invalid JSON structure');
            }

            if (loadedData.savedStyles && typeof onReceiveSavedStyles === 'function') {
                onReceiveSavedStyles(loadedData.savedStyles);
            }

            if (Array.isArray(loadedData.favSavedStyles)) {
                console.log("FunctionsLoadFile.jsx read favSavedStyles", loadedData.favSavedStyles);

                const loadFavSavedStyles = (favStylesArray) => {
                    setTimeout(() => {
                        favStylesArray.forEach((styleId) => {
                            const match = styleId.match(/^favButtonGroupBox-(\d+)$/);
                            if (match) {
                                const index = match[1];
                                const container = document.getElementById('toolSavedStylesContainerPosition');
                                if (container) {
                                    const buttonId = `buttonAddToFavoriteSavedStyles-${index}`;
                                    const button = container.querySelector(`button#${buttonId}`);
                                    if (button) {
                                        console.log(`${buttonId} FOUND`);
                                        button.click();
                                    } else {
                                        console.log(`${buttonId} NOT FOUND`);
                                    }
                                }
                            }
                        });
                    }, 2000);
                };

                loadFavSavedStyles(loadedData.favSavedStyles);
            }

            // ✅ Strip .onewriter or .json extension
            const rawFileName = file.name.replace(/\.(onewriter|json)$/i, '');
            const fileNameInput = document.getElementById('fileNameInput');
            if (fileNameInput) fileNameInput.value = rawFileName;

            console.log(`Loaded file name (string): "${rawFileName}"`);

            // ✅ Final step: scroll up to top
            clickScrollUpToFirstAfterLoad();
        } catch (error) {
            console.error('Error parsing JSON:', error);
        }
    };
    reader.readAsText(file);
};

// ✅ New helper function
const clickScrollUpToFirstAfterLoad = () => {
    setTimeout(() => {
        const scrollUpButton = document.getElementById('buttonScrollUp');
        if (scrollUpButton) {
            console.log('clickScrollUpToFirstAfterLoad: buttonScrollUp found, clicking...');
            scrollUpButton.click();
        } else {
            console.warn('clickScrollUpToFirstAfterLoad: buttonScrollUp not found in DOM.');
        }
    }, 1000);
};

// Optional UI component stub
const FunctionsLoadFile = () => null;
export default FunctionsLoadFile;
